import React from 'react';

const Home = () => {
  return (
    <div style={{ padding: '20px' }}>
      <h1>Welcome to Our Business</h1>
      <p>This is the home page of your small business website.</p>
      <p>Add your company introduction, featured services, or any other content you'd like to showcase on the main page.</p>
    </div>
  );
};

export default Home;
